import React from 'react';

const TableSkeleton = ({ isGridView, columns, rows }) => {
  if (isGridView) {
    return (
      <div className="skeleton-grid-view">
        {Array.from({ length: rows }).map((_, idx) => (
          <div key={idx} className="skeleton-grid-item">
            <div className="skeleton-grid-header">
              <div className="skeleton-title"></div>
              <div className="skeleton-checkbox"></div>
            </div>
            <div className="skeleton-grid-content">
              {Array.from({ length: columns }).map((_, colIdx) => (
                <div key={colIdx} className="skeleton-grid-field">
                  <div className="skeleton-label"></div>
                  <div className="skeleton-value"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="skeleton-table">
      <div className="skeleton-table-header">
        <div className="skeleton-row">
          {Array.from({ length: columns }).map((_, idx) => (
            <div key={idx} className="skeleton-cell"></div>
          ))}
        </div>
      </div>
      <div className="skeleton-table-body">
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <div key={rowIdx} className="skeleton-row">
            {Array.from({ length: columns }).map((_, colIdx) => (
              <div key={colIdx} className="skeleton-cell"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = `
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }

  .skeleton-table,
  .skeleton-grid-view {
    width: 100%;
    animation: pulse 1.5s ease-in-out infinite;
  }

  /* Table View Styles */
  .skeleton-table {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
  }

  .skeleton-table-header {
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
  }

  .skeleton-row {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 16px;
  }

  .skeleton-table-body .skeleton-row {
    border-bottom: 1px solid #e5e7eb;
  }

  .skeleton-table-body .skeleton-row:last-child {
    border-bottom: none;
  }

  .skeleton-cell {
    flex: 1;
    height: 20px;
    background-color: #e5e7eb;
    border-radius: 4px;
    margin: 0 8px;
  }

  /* Grid View Styles */
  .skeleton-grid-view {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
    padding: 16px;
  }

  .skeleton-grid-item {
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;
  }

  .skeleton-grid-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .skeleton-title {
    width: 70%;
    height: 24px;
    background-color: #e5e7eb;
    border-radius: 4px;
  }

  .skeleton-checkbox {
    width: 20px;
    height: 20px;
    background-color: #e5e7eb;
    border-radius: 4px;
  }

  .skeleton-grid-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .skeleton-grid-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .skeleton-label {
    width: 30%;
    height: 16px;
    background-color: #e5e7eb;
    border-radius: 4px;
  }

  .skeleton-value {
    width: 100%;
    height: 20px;
    background-color: #e5e7eb;
    border-radius: 4px;
  }
`;

// Add styles to document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default TableSkeleton;